import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import React from 'react'
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { corporateColor, lightBackground, toqueColor } from '../../../theme/colors'
import { Clock } from '../../../components/Svg'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  time: string
  uri: string
  hasBg?: boolean
  hasDelete?: {
    onDelete: () => void
  }
  onPress?: () => void
}

export const PhotoCard = ({ title, time, uri, hasDelete, onPress, hasBg }: Props) => {
  const { t } = useTranslation()
  return (
    <TouchableOpacity
      style={[style.card, hasBg && { backgroundColor: lightBackground }]}
      onPress={onPress}
      activeOpacity={0.8}
    >
      <View style={style.photoContainer}>
        <Image style={style.photo} source={{ uri }} />
      </View>

      <View style={[hasDelete ? { flex: 1 } : { flex: 2 }]}>
        <Text style={style.title}>{title}</Text>

        <View style={{ flexDirection: 'row' }}>
          <Clock width={25} height={25} />
          <Text style={[style.label, { marginLeft: 6 }]}>
            {t('Hora')}: {time}
          </Text>
        </View>
      </View>
      {hasDelete && (
        <View style={{ flex: 1 }}>
          <TouchableOpacity style={{ padding: 10 }} onPress={hasDelete.onDelete}>
            <FontAwesomeIcon icon={faTrashAlt} size={20} color={toqueColor} />
          </TouchableOpacity>
        </View>
      )}
    </TouchableOpacity>
  )
}

const style = StyleSheet.create({
  card: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
  },
  photoContainer: {
    flex: 1,
    alignItems: 'center',
  },
  photo: {
    width: 100,
    height: 100,
    borderColor: 'black',
    borderWidth: 2,
    borderRadius: 10,
  },
  title: {
    fontWeight: '500',
    fontSize: 18,
    lineHeight: 22,
    color: corporateColor,
    marginBottom: 8,
  },
  label: {
    fontSize: 16,
    fontWeight: '400',
    color: corporateColor,
  },
})
